<template>
  <div class="xt-dialog__wrapper-new" v-show="visible">
    <transition name="dialog">
      <div v-show="visible" >
        <div class="xt-dialog" :class="{'no-button': noButton}" :style="dialogStyle">
          <i class="el-icon-close xt-dialog__close" @click="handleCancel"  v-if="noButton && !noClose" title="关闭"></i>
          <div class="xt-dialog__title" :style="titleStyle">{{ title }}</div>
          <div class="xt-dialog-slot">
            <slot/>
          </div>
          <div class="xt-dialog__buttons" v-if="!noButton">
            <template v-if="type=== 'confirm'">
              <div class="content-btn">
                <xt-button-web  :style="buttonStyle" @click="handleCancel" class="cancel-btn btn-web">{{cancelText}}</xt-button-web>
                <xt-button-web  :style="buttonStyle" @click="handleConfirm" class="confirm-btn btn-web">{{confirmText}}</xt-button-web>
              </div>
            </template>
            <xt-button-web v-else class="xt-dialog-single-button"
                           style="width: 228px;"
                           :style="buttonStyle"
                           @click="handleConfirm">{{ confirmText }}</xt-button-web>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import XtButtonWeb from "./xtButtonWeb";
export default {
  components: {XtButtonWeb},
  props: {
    cancelText: {
      type: String,
      default: '取消'
    },
    confirmText: {
      type: String,
      default: '提交'
    },
    // confirm, alert
    type: {
      type: String,
      default: 'alert'
    },
    title: {
      type: String,
      default: '提示'
    },
    titleStyle: {
      type: String
    },
    noButton: {
      type: Boolean,
      default: false
    },
    noClose: {
      type: Boolean,
      default: false
    },
    buttonStyle: {
      type: String
    },
    dialogStyle: {
      type: String,
      default:"position:relative"
    },
    visible: {
      type: Boolean,
      default: true
    },
    disConfirm: {
      type: Boolean,
      default: false
    },
    disCancel: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      handling: false
    }
  },
  methods: {
    handleCancel() {
      this.$emit('cancel')
    },
    handleConfirm() {
      if (!this.disConfirm){
        this.$emit('confirm')
      }
    }
  }
}
</script>
<style lang="less" scoped>
@import '../css/mobile.less';

.xt-dialog__wrapper-new {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: auto;
  z-index: 99999999999;
  margin: 0;
  background: rgba(0, 0, 0, 0.2);

  .xt-dialog {
    margin-top: 300px;
    margin-left: auto;
    margin-right: auto;
    max-width: 520px;
    min-height: 238px;
    background: #FFF;
    box-sizing: border-box;
    padding: 26px 27px 30px 27px;
    overflow: hidden;
    position: relative;
    border-radius: 3px;

    &.no-button {
      padding-bottom: 20px;
    }

    .xt-dialog__title {
      text-align: center;
      font-size: 18px;
      font-weight: 500;
      color: #333;
      font-weight: bold;
    }

    .xt-dialog-slot{
      margin-top: 39px;
      text-align: center;
      color: #1A1A1A;
    }

    .xt-dialog__buttons {
      width: 100%;
      height: 45px;
      position: absolute;
      bottom: 30px;
      margin-left: -27px;
      display: flex;
      .content-btn{
        margin: auto auto;
        display: flex;
        align-items: center;
        justify-content: center;
        .btn-web{
          width: 120px;
          height: 42px;
        }
        .confirm-btn{
          margin-left: 64px;
        }
        .cancel-btn{
          background: #FFFFFF;
          color: #4c7ec5;
        }
      }
      .xt-dialog-single-button{
        margin-left: auto;
        margin-right: auto;
      }
    }
  }

  .xt-dialog__close {
    position: absolute;
    right: 7px;
    top: 7px;
    color: #999;
    font-size: 22px;
    font-weight: 500;
    cursor: pointer;
  }
}

@keyframes rise {
  from {
    opacity: .4;
    transform: scale(.7);
  }
}
@keyframes visible {
  from {
    opacity: .4;
  }
}
.dialog-enter-active{
  animation: rise .2s;
}
.wrapper-enter-active{
  animation: visible .2s;
}
</style>
